module.exports = __webpack_public_path__ + "fonts/untitled-font-1.0dc06d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/untitled-font-1.woff
// module id = ./src/assets/fonts/untitled-font-1.woff
// module chunks = 34